export const clientPayments = {
    namespaced: true,
    state: {
        cardsStatus: 'initial',
        cards: [],
        cardsPagination: {
            total: 0,
            current: 1
        }
    },
    mutations: {
        SET_CARDS_STATUS(state, cardsStatus) {
            state.cardsStatus = cardsStatus
        },
        SET_CARDS(state, cards) {
            state.cards = cards
        },
        SET_PAGINATION_TOTAL(state, total) {
            state.pagination.total = total
        },
        SET_PAGINATION_CURRENT(state, current) {
            state.pagination.current = current
        }
    },
    actions: {
        fetchCards({ commit, getters, dispatch }) {
            commit('SET_CARDS_STATUS', 'pending')
            return this.$api.get(`client/v2/payments/cards?page=${getters.cardsPaginationCurrent}`).then(response => {
                if(response.status === 200) {
                    commit('SET_CARDS', response.data.data.items)
                    commit('SET_PAGINATION_TOTAL', response.data.data.metadata.pageCount)
                    commit('SET_CARDS_STATUS', 'idle')
                }
            }).catch(() => {
                dispatch('resetFromInitialState', { module: 'payments' }, { root: true })
                commit('SET_CARDS_STATUS', 'idle')
            })
        },
        setCardsPage({ commit }, page) {
            commit('SET_PAGINATION_CURRENT', page)
        }
    },
    getters: {
        cardsStatus: state => state.cardsStatus,
        cards: state => state.cards,
        cardsPaginationTotal: state => state.cardsPagination.total,
        cardsPaginationCurrent: state => state.cardsPagination.current
    }
}
